export default "__VITE_ASSET__ca51221c__"